// extracted by mini-css-extract-plugin
module.exports = {"main-component":"executePopupCorrectTick_main-component__28WWf"};